import { ErrorHandler } from "@angular/core";
import {
  AssetRecoveryTarget,
  recoverFromAssetLoadError,
} from "./utils/asset-load-recovery";

export class AppErrorHandler implements ErrorHandler {
  constructor(
    private readonly delegate: ErrorHandler,
    private readonly recoveryTarget: AssetRecoveryTarget = window,
  ) {}

  handleError(error: any): void {
    try {
      this.delegate.handleError(error);
    } finally {
      recoverFromAssetLoadError(error, this.recoveryTarget);
    }
  }
}
